var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Input Input--text",class:{ 'Input--desktop': _vm.desktop }},[_c('label',{staticClass:"Input-labelText",class:{
            'Input--white': _vm.white,
            'Input--error': _vm.error,
    },attrs:{"for":_vm.name}},[_vm._v("\n        "+_vm._s(_vm.label)+":\n    ")]),_c('input',{attrs:{"type":_vm.type,"name":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }